import aradasLogo from "../../images/Aradas_Black.png";
import styled from "styled-components";
import { useContext } from "react";
import { ExitToApp } from "@mui/icons-material";
import { AuthContext } from "../../context/authContext/AuthContext";
import { logout } from "../../context/authContext/AuthActions";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
	width: 100%;
	height: 50px;
	background-color: #e6f3f9;
	position: sticky;
	top: 0;
	z-index: 999;
`
const Wrapper = styled.div`
	height: 100%;
	padding: 0px 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
`

const Left = styled.div`
	flex: 1;
	align-items: center;
`

const Right = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: flex-end;
`
const MenuItem = styled.div`
	color: white;
	font-size: 14px;
	cursor: pointer;
	align-items: center;
	margin-right: 10px;
`
const Logo = styled.img`
	max-height: 20px;
`;



const Navbar = () => {
	const navigate = useNavigate();
  const { user, dispatch } = useContext(AuthContext);
	
	const handleLogout = () => {
		dispatch(logout());
		navigate("/");
	}

  return (
    <Container>
      <Wrapper>
				<Left>
          <Logo src={aradasLogo} alt="Aradas UAB" />
        </Left>
        <Right>
					<MenuItem>{user ? user.salesforceAccountName : "-" } - {user ? user.contactPerson : "-"}</MenuItem>
					<MenuItem>
						<ExitToApp onClick={() => handleLogout()} />
					</MenuItem>
        </Right>
      </Wrapper>
    </Container>
  );
}

export default Navbar;
